const DEFAULT_CURRENCY = { code: "USD", symbol: "$", locale: "en-US" };
const KNOWN_CURRENCIES = {
  USD: DEFAULT_CURRENCY,
  GBP: { code: "GBP", symbol: "£", locale: "en-GB" },
  EUR: { code: "EUR", symbol: "€", locale: "en-IE" },
  AUD: { code: "AUD", symbol: "$", locale: "en-AU" },
};

export function getCurrencyMeta(code) {
  const upper = typeof code === "string" ? code.trim().toUpperCase() : "";
  if (upper && KNOWN_CURRENCIES[upper]) {
    return KNOWN_CURRENCIES[upper];
  }
  return { ...DEFAULT_CURRENCY, code: upper || DEFAULT_CURRENCY.code };
}

export function formatCurrencyAmount(amount, currencyCode, opts = {}) {
  const { code, locale: currencyLocale, symbol } = getCurrencyMeta(currencyCode);
  const value = typeof amount === "number" && !Number.isNaN(amount) ? amount : 0;

  const {
    locale = currencyLocale,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = opts || {};

  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
      minimumFractionDigits,
      maximumFractionDigits,
    });
    const formatted = formatter.format(value);
    return formatted;
  } catch (err) {
    return `${symbol}${value.toFixed(2)}`;
  }
}
